import * as angular from 'angular';
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.agents')
  .factory('AgentsAssistantsAPI', AgentsAssistantsAPI);


function AgentsAssistantsAPI(): BringozApi {
  return {
    base: `/agents/assistants`,
    infiniteScroll: {
      address: `/agents/assistants`,
      cmd: 'GET'
    },
    actions: {

    }
  }
}

